export const esAU = {
  abnEntity: 'un Número de Empresa Australiano',
  abn: 'ABN',
  abnLowercase: 'ABN',
  abnSearchName: 'Registro de Empresas Australiano',
  abns: 'ABNs',
  abnsLowercase: 'ABNs',
  companyInduction: 'Inducción de la Empresa',
  companyInductions: 'Inducciones de la Empresa',
  defect: 'Defecto',
  defects: 'Defectos',
  drawing: 'Dibujo',
  drawings: 'Dibujos',
  favourite: 'Favorito',
  favourites: 'Favoritos',
  induct: 'Inducir',
  inducts: 'Induce',
  inducted: 'Inducido',
  inducting: 'Induciendo',
  induction: 'Inducción',
  inductions: 'Inducciones',
  itp: 'ITP',
  itps: 'ITPs',
  people: 'Personal',
  peoples: 'Personal',
  preStart: 'Charla Previa',
  preStarts: 'Charlas Previas',
  project: 'Proyecto',
  projects: 'Proyectos',
  projectHoursBudget: 'Presupuesto de Horas del Proyecto',
  projectHoursBudgets: 'Presupuestos de Horas del Proyecto',
  placeholderAddress: '123 Collins St, Melbourne 3000',
  placeholderProjectName: '123 Collins St',
  placeholderPhoneNumber: '0412 345 678',
  register: 'Registro',
  registers: 'Registros',
  sdsLibrary: 'Biblioteca SDS',
  sdsLibraries: 'Bibliotecas SDS',
  signOn: 'Registro de Entrada',
  signOns: 'Registros de Entrada',
  siteInduction: 'Inducción del Sitio',
  siteInductions: 'Inducciones del Sitio',
  siteDiary: 'Diario de Obra',
  siteDiaries: 'Diarios de Obra',
  staff: 'Personal',
  staffs: 'Personal',
  subcontractor: 'Subcontratista',
  subcontractors: 'Subcontratistas',
  swms: 'SWMS',
  swmss: 'SWMS', // plural, mantiene el acrónimo igual
  swmsFullTitle: 'Declaración de Método de Trabajo Seguro',
  ticket: 'Licencia',
  tickets: 'Licencias',
  timesheet: 'Hoja de Tiempo',
  timesheets: 'Hojas de Tiempo',
  worker: 'Trabajador',
  workers: 'Trabajadores',
}
